/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-time': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M8 15.334A7.333 7.333 0 118 .667a7.333 7.333 0 010 14.667zM8 14A6 6 0 108 2a6 6 0 000 12zm3.333-6.666H8.666V4H7.333v4.667h4V7.334z" _fill="#566473"/>'
  }
})
